import TemplateView from '../../../TemplateView'
import messageResource from '../../../messageResource'
import {MONTH_LICENSES_DURATION, USERS_LIMITED_PACKAGES, PricingModelType, purchaseCardType, YEAR_LICENSES_DURATION} from '../constants'
import {CURRENT_PRODUCT, Product} from 'constants'
import {DateFormat} from '../../../date_format'
import {isInt} from '../../../atUtils'
import SimpleListMenuButton from '../../../SimpleListMenuButton'
import DatePickerMenu from '../../../controls/dateControls/DatePickerMenu'
import CorporateScheduleCalculator from '../../../controls/dateControls/CorporateScheduleCalculator'
import Button from '../../../components/Button'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import {getEndDate, getPrice, getPurchasePeriod, getStartDate, getUsersCount, isSelectUnlimitedUsers} from './chooser/selectors'
import {getCurrentUsedUser, getMaxUsersToUnlimited, getPricingModelType, getUsersLowerLimit} from '../selectors'
import {setPurchasePeriod, setStartDate, setUnlimited, setUsersCount} from './chooser/actions'
import NumberFormatter from '../../../number_formatter'

class PurchaseCard extends TemplateView {
    constructor({
        cardType = purchaseCardType.RENEWAL,
        product = CURRENT_PRODUCT,
        onSwitchToFreeButtonClick = () => {},
        onPurchaseClick = () => {},
        setUnlimited = () => {},
        setUsersCount = () => {},
        setPurchasePeriod = () => {},
        setLicenseStartDate = () => {},
    } = {}) {
        super()

        this.params = {
            cardType,
            product,
        }

        this.actions = {
            onSwitchToFreeButtonClick,
            onPurchaseClick,
            setUnlimited,
            setUsersCount,
            setPurchasePeriod,
            setLicenseStartDate,
        }

        this.state = {
            pricingModelType: PricingModelType.USER,
            price: 0,
            purchasePeriod: 1,
            startDate: new Date(),
            endDate: new Date(2020, 0, 1),
            maxUsersToUnlimited: 0,
            currentUsersCountSelected: 0,
            isUnlimitedSelected: false,
            currentUsedUser: 0,
            usersLowerLimit: 0,
        }

        this.onStatePropertyChanged('price', (price) => {
            this.$price.text(messageResource.getMessage('licenses.price', [this.numberFormatter.format(price / 100)]))
        })

        this.onStatePropertyChanged('purchasePeriod', (purchasePeriod) => {
            this.periodSelector.setSelectedItem(purchasePeriod === MONTH_LICENSES_DURATION ? this.monthlyPeriodItem : this.annualPeriodItem)
        })

        this.onStatePropertyChanged('startDate', (startDate) => {
            if (this.params.cardType === purchaseCardType.RENEWAL) {
                this.$title.text(messageResource.getMessage('licenses.renewal', [this.dateFormat.formatDate(startDate)]))
            } else {
                this.$upgradeDate.text(this.dateFormat.formatDate(startDate))
            }
        })

        this.onAnyStatePropertyChanged(['startDate', 'endDate'], () => {
            this.$periodDates.text(messageResource.getMessage('licenses.renewal.period_dates', [
                this.dateFormat.formatDate(this.state.startDate),
                this.dateFormat.formatDate(this.state.endDate)
            ]))
        })

        this.onAnyStatePropertyChanged(['isUnlimitedSelected', 'pricingModelType'], ({isUnlimitedSelected, pricingModelType}) => {
            this.$switchToUnlimitedButton.toggle(!isUnlimitedSelected)
            this.$payPerUserButton.toggle(isUnlimitedSelected)
            this.$usersCount.toggle(!isUnlimitedSelected && pricingModelType === PricingModelType.USER)
            this.$usersCountByPackage.toggle(!isUnlimitedSelected && pricingModelType === PricingModelType.PACKAGE)
        })

        this.onAnyStatePropertyChanged(['isUnlimitedSelected', 'currentUsedUser'], () => {
            this.$currentUsersCount.html(messageResource.getMessage(
                this.state.isUnlimitedSelected ? 'licenses.renewal.unlimited_current_users_count' : 'licenses.renewal.current_users_count',
                [this.state.currentUsedUser]
            ))
        })

        this.onAnyStatePropertyChanged(['maxUsersToUnlimited', 'currentUsersCountSelected', 'isUnlimitedSelected'], () => {
            this.$usersCount.val(this.state.currentUsersCountSelected)
            this.usersCountByPackage.setSelectedItem(this.state.currentUsersCountSelected)

            const disablePurchase = !this.state.isUnlimitedSelected && this.state.currentUsersCountSelected > this.state.maxUsersToUnlimited
            this.$error.toggle(disablePurchase)
            this.$price.toggle(!disablePurchase)
            this.purchaseButton.setState({disabled: disablePurchase})
        })

        this.onStatePropertyChanged('maxUsersToUnlimited', (maxUsersToUnlimited) => {
            this.$error.text(messageResource.getMessage('licenses.unlimited_error', [maxUsersToUnlimited]))
        })
    }

    templateHtml() {
        return '<div class="purchaseCard">' +
               '    <div class="cardHeader">' +
               '        <div class="img"/>' +
               '        <div class="titleContainer">' +
               '            <div class="title"/>' +
               '            <div class="note"><%=upgradeNote%></div>' +
               '        </div>' +
               '        <div class="switchToFreeButton"><%=switchToFree%></div>' +
               '    </div>' +
               '    <div class="purchaseInfo">' +
               '        <div class="usersSection">' +
               '            <input class="usersCount" type="text" maxlength="6"/>' +
               '            <div class="usersCountByPackage"/>' +
               '            <div class="currentUsersCount"/>' +
               '            <div class="switchToUnlimitedButton"><%=switchToUnlimited%></div>' +
               '            <div class="payPerUserButton"><%=payPerUser%></div>' +
               '        </div>' +
               '        <div class="periodSection">' +
               '            <div class="periodSelector"/>' +
               '            <div class="dateFrom">' +
               '                <div class="from"><%=upgradeFrom%></div>' +
               '                <div class="date"/>' +
               '            </div>' +
               '            <div class="periodDates"/>' +
               '        </div>' +
               '    </div>' +
               '    <div class="cardFooter">' +
               '        <div class="error"/>' +
               '        <div class="price"/>' +
               '        <div class="purchaseButton"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            upgradeNote: 'licenses.upgrade.note',
            switchToFree: 'licenses.chooser.card_free_title',
            switchToUnlimited: 'licenses.switch_to_unlimited',
            payPerUser: 'licenses.pay_per_user',
            upgradeFrom: 'common.from',
            purchase: 'licenses.purchase',
        }
    }

    afterRender() {
        this.$productLogo = this.find('.img')
        this.$title = this.find('.titleContainer .title')
        this.$switchToFreeButton = this.find('.switchToFreeButton')
        this.$upgradeNote = this.find('.titleContainer .note')
        this.$usersCount = this.find('.usersCount')
        this.$currentUsersCount = this.find('.currentUsersCount')
        this.$switchToUnlimitedButton = this.find('.switchToUnlimitedButton')
        this.$payPerUserButton = this.find('.payPerUserButton')
        this.$periodDates = this.find('.periodDates')
        this.$upgradeDateFrom = this.find('.periodSection .dateFrom')
        this.$upgradeDate = this.find('.periodSection .dateFrom .date')
        this.$error = this.find('.cardFooter .error')
        this.$price = this.find('.cardFooter .price')

        this.$productLogo.toggleClass('at', this.params.product === Product.actiTIME)
        this.$productLogo.toggleClass('ap', this.params.product === Product.actiPLANS)

        if (this.params.cardType === purchaseCardType.RENEWAL) {
            this.$title.text(messageResource.getMessage('licenses.renewal', [this.state.startDate]))
        } else {
            this.$title.text(messageResource.getMessage('licenses.upgrade'))
        }

        this.$switchToFreeButton.toggle(this.params.cardType === purchaseCardType.RENEWAL)
        this.$switchToFreeButton.on('click', () => this.actions.onSwitchToFreeButtonClick())

        this.$upgradeNote.toggle(this.params.cardType === purchaseCardType.UPGRADE)

        this.$usersCount.on('change', () => {
            let value = this.$usersCount.val()
            if (isInt(value) && parseInt(value) >= this.state.usersLowerLimit) {
                this.actions.setUsersCount(parseInt(value))
            } else {
                this.$usersCount.val(this.state.currentUsersCountSelected)
            }
        })

        this.$usersCountByPackage = this.find('.usersCountByPackage')
        this.usersCountByPackage = new SimpleListMenuButton({
            itemHtmlCallback: item => item,
            onSelect: item => this.actions.setUsersCount(item),
            itemHeight: 30,
        }).init(this.$usersCountByPackage)
        this.usersCountByPackage.setItems(USERS_LIMITED_PACKAGES)

        this.$switchToUnlimitedButton.click(() => this.actions.setUnlimited(true))
        this.$payPerUserButton.click(() => this.actions.setUnlimited(false))

        this.periodSelector = new SimpleListMenuButton({
            itemHtmlCallback: item => item.label,
            onSelect: item => this.actions.setPurchasePeriod(item.duration),
            itemHeight: 30,
        }).init(this.find('.periodSelector'))

        this.monthlyPeriodItem = {label: messageResource.getMessage('licenses.renewal.month'), duration: MONTH_LICENSES_DURATION}
        this.annualPeriodItem = {label: messageResource.getMessage('licenses.renewal.year'), duration: YEAR_LICENSES_DURATION}
        this.periodSelector.setItems([this.monthlyPeriodItem, this.annualPeriodItem], this.monthlyPeriodItem)

        this.$upgradeDateFrom.toggle(this.params.cardType === purchaseCardType.UPGRADE)
        if (this.params.cardType === purchaseCardType.UPGRADE) {
            this.upgradeDateFromMenu = new DatePickerMenu({
                scheduleCalculator: new CorporateScheduleCalculator().init(window.invertedDaysDateMap, window.SystemSettings.defaultWorkSchedule),
                parentEl: this.getEl()[0],
                showClearButton: false,
                showOkCancelButtons: false,
                addClassesStr: 'upgradeDateSelector',
            }).init()

            this.$upgradeDate.on('click', () => {
                this.upgradeDateFromMenu.setValue(this.state.startDate)
                this.upgradeDateFromMenu.showAt(this.$upgradeDate, (date) => this.actions.setLicenseStartDate(date), () => {})
            })
        }

        this.purchaseButton = new Button({
            additionalClass: 'purchase',
            label: messageResource.getMessage('licenses.purchase'),
            onClickCb: () => this.actions.onPurchaseClick()
        }).init(this.find('.cardFooter .purchaseButton'))
        this.purchaseButton.getEl().hover(
            () => {
                if (!(!this.state.isUnlimitedSelected && this.state.currentUsersCountSelected > this.state.maxUsersToUnlimited)) {
                    this.getEl().addClass('active')
                }
            },
            () => this.getEl().removeClass('active'),
        )

        this.dateFormat = new DateFormat(window.SystemSettings.dateFormat)
        this.numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)

        this.renderInitialState()
    }
}

export default connect(
    (state) => ({
        pricingModelType: getPricingModelType(state),
        price: getPrice(state),
        purchasePeriod: getPurchasePeriod(state),
        startDate: getStartDate(state),
        endDate: getEndDate(state),
        maxUsersToUnlimited: getMaxUsersToUnlimited(state),
        currentUsersCountSelected: getUsersCount(state),
        isUnlimitedSelected: isSelectUnlimitedUsers(state),
        currentUsedUser: getCurrentUsedUser(state),
        usersLowerLimit: getUsersLowerLimit(state),
    }),
    (dispatch) => ({
        setUnlimited: bindActionCreators(setUnlimited, dispatch),
        setUsersCount: bindActionCreators(setUsersCount, dispatch),
        setPurchasePeriod: bindActionCreators(setPurchasePeriod, dispatch),
        setLicenseStartDate: bindActionCreators(setStartDate, dispatch),
    })
)(PurchaseCard)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/PurchaseCard.js